import zhCN from "antd/es/locale/zh_CN";
export default {
    ...zhCN,
    label: "中文",
    value: "zh",

    // 菜单标题
    overview: "概况",
    incomeStatistic: "收益统计",
    incomeRecord: "JP&LC 收益流水",
    paymentStatistic: "交上统计",
    lowerLevelPaymentStatistic: "下级交上统计",
    lowerLevelStatistic: "下级统计",
    gameStatistic: "游戏统计",
    integralConsumeStatistic: "积分消耗统计",
    checkDataStatistic: "核对数据统计",
    kpokerUnionBetRecord: "API联盟注单流水",
    kpokerUnionIntegralRecord: "API联盟积分流水",
    integralTransferRecord: "积分转出入记录",
    diamondManage: "钻石统计",
    diamondStatistic: "钻石统计",
    diamondOpeningStartStatistic: "钻石开局消耗统计",
    diamondExchangeIntegralStatistic: "钻石兑换积分统计",
    diamondDistributionStatistic: "钻石分销统计",
    diamondRecord: "钻石流水",
    proxyList: "代理管理",
    proxyDetail: "代理详情",
    proxyStatistic: "代理统计",
    lowerLevelProxyStatistic: "下级代理统计",
    gamblingRecord: "牌局流水",
    betRecord: "注单流水",
    integralRecord: "积分流水",
    propsConsumeRecord: "道具消耗流水",
    activityManage: "活动管理",
    activityLuckyCard: "LuckyCard",
    activityLuckyCardRecord: "LuckyCard击中记录",
    activityLuckyCardRewardReview: "LuckyCard奖励审核",
    activityBadBeatJackpot: "BadBeatJackpot",
    activityBadBeatJackpotRewardRecord: "BadBeatJackpot奖励记录",
    activityHighHandCard: "HighHandCard",
    activityHandRank: "手数排行",
    dailyChallenge: "每日挑战",
    dailyChallengeRecord: "每日挑战活动记录",
    dailyChallengeDetail: "每日挑战活动明细",
    activityPoster: "海报管理",
    unionManage: "子联盟管理",
    unionList: "联盟列表",
    unionDetail: "联盟详情",
    clubManage: "俱乐部管理",
    clubList: "俱乐部列表",
    clubDetail: "俱乐部详情",
    proxyManage: "代理管理",
    proxyList: "代理列表",
    proxyDetail: "代理详情",
    playerManage: "玩家管理",
    playerList: "玩家管理",
    playerStatistic: "玩家统计",
    playerDetail: "玩家详情",
    tableManage: "牌桌管理",
    tableRoundList: "牌局列表",
    tableConfigList: "配置列表",
    tableRoundRecordList: "牌局记录",
    tableConfigStatistic: "配置统计",
    mttManage: "MTT",
    mttCreate: "MTT创建",
    mttList: "MTT列表",
    mttRoundList: "MTT牌局列表",
    mttTicket: "门票",
    mttTicketList: "门票列表",
    mttDataStatistic: "MTT数据统计",
    partnerManage: "伙牌管理",
    partnerCardQuery: "伙牌查询工具",
    partnerCardStatistic: "疑似伙牌统计",
    derivativeDetection: "倒分检测",
    gameCurrencyTypeProportion: "游戏币类型比例",
    ipGpsWhitelist: "IP&GPS白名单",
    codeSendRecord: "验证码发送记录",
    integralProportion: "积分比例",
    customerManage: "客服管理",
    signaturePackageDownloadConfiguration: "签名包下载配置",
    localCurrencyRatio: "本地币比例",
    accountManage: "账号管理",
    accountSetting: "账号设置",
    accountSwitch: "切换账号",

    // Message提示
    closeSuccessMessage: "关闭成功",
    deleteSuccessMessage: "删除成功",
    addSuccessMessage: "添加成功",
    modifySuccessMessage: "修改成功",
    saveSuccessMessage: "保存成功",
    updateSuccessMessage: "更新成功",
    operationSuccessMessage: "操作成功",
    exportSuccessMessage: "导出成功",
    importSuccessMessage: "导入成功",
    createSuccessMessage: "创建成功",
    publishSuccessMessage: "发布成功",
    dissolveSuccessMessage: "解散成功",
    batchDissolveSuccessMessage: "批量解散成功",
    applySuccessMessage: "报名成功",
    batchApplaySuccessMessage: "批量报名成功",
    cancelApplySuccessMessage: "取消报名成功",
    destroySuccessMessage: "注销成功",
    giveSuccessMessage: "赠送成功",
    setSuccessMessage: "设置成功",
    finishSuccessMessage: "结束成功",
    rechargeSuccessMessage: "充值成功",
    editSuccessMessage: "编辑成功",
    offlineSuccessMessage: "下线成功",
    agreeApplicationMessage: "已同意申请",
    refuseApplicationMessage: "已拒绝申请",
    noDataMessage: "暂无数据",
    matchEndMessage: "赛事已结束",
    integralNotEnoughMessage: "抱歉，柜台积分不足！",
    uploadeTypeMessage: "只能上传 {} 格式的文件！",
    uploadeSizeMessage: "文件大小不能超过 {}MB！",
    insufficientPointsMessage: "抱歉，柜台积分不足！",
    broughtRangeCannotConsistentMessage: "带入范围不能一致！",
    seatNumSetMessage: "PLO6人数必须小于8人！",
    autoStartUserNumMessage: "PLO6自动开始人数必须小于8人！",

    // Confirm确认框
    deleteConfirm: "确定要删除吗？",
    logoutConfirm: "确定要退出当前登录吗？",
    publishConfirm: "确定要发布吗？",
    dissolveConfirm: "确定要解散吗？",
    batchDissolveConfirm: "确定要批量解散吗？",
    destroyConfirm: "确定要注销吗？",
    deleteAllConfirm: "确定要删除所有吗？",
    closeAllConfirm: "确定要关闭所有吗？",
    createConfirm: "确定要创建吗？",
    finishConfirm: "确定要结束吗？",
    rechargeIntegralConfirm: "确定要往奖池充值 {} 积分吗？",
    offlineConfirm: "确定要下线吗？",
    agreenConfirm: "确定要同意吗？",
    refuseConfirm: "确定要拒绝吗？",
    reissueConfirm: "确定要补发吗？",
    noReissueConfirm: "确定要不补发吗？",
    editConfirm: "确认要修改吗？",

    // 输入框
    phoneAccount: "手机账号",
    phoneAccountPlaceholder: "请输入手机账号",
    phoneAccountVerify: "手机账号不能为空！",
    emailAccount: "邮箱账号",
    emailAccountPlaceholder: "请输入邮箱账号",
    emailAccountVerify: "邮箱账号不能为空！",
    account: "账号",
    accountPlaceholder: "请输入账号",
    accountVerify: "账号不能为空！",
    password: "密码",
    passwordPlaceholder: "请输入密码",
    passwordVerify: "密码不能为空！",
    oldPassword: "原密码",
    oldPasswordPlaceholder: "请输入原密码",
    oldPasswordVerify: "原密码不能为空！",
    newPassword: "新密码",
    newPasswordPlaceholder: "请输入新密码",
    newPasswordVerify: "新密码不能为空！",
    confrimPassword: "确认密码",
    confrimPasswordPlaceholder: "请输入确认密码",
    confrimPasswordVerify: "确认密码不能为空！",
    confrimPasswordVerify2: "两次输入密码不一致！",
    rechargeAmount: "充值数量",
    rechargeAmountPlaceholder: "请输入充值数量",
    rechargeAmountVerify: "充值数量不能为空！",
    roundBonus: "每轮奖金（总计：{}）",
    roundBonusPlaceholder: "请输入每轮奖金",
    roundBonusVerify: "每轮奖金不能为空！",
    rankRewrad: "第{}名",
    rankRewradPlaceholder: "请输入第{}名奖金",
    rankRewradVerify: "第{}名奖金不能为空！",
    serviceProportion: "服务费占比",
    serviceProportionPlaceholder: "请输入服务费占比",
    serviceProportionVerify: "服务费占比不能为空！",
    insuranceProportion: "保险占比",
    insuranceProportionPlaceholder: "请输入保险占比",
    insuranceProportionVerify: "保险占比不能为空！",
    cowboyProportion: "牛仔占比",
    cowboyProportionPlaceholder: "请输入牛仔占比",
    cowboyProportionVerify: "牛仔占比不能为空！",
    gambleName: "牌局名称",
    gambleNamePlaceholder: "请输入牌局名称",
    gambleNameVerify: "牌局名称不能为空！",
    minEmptyTable: "最少空位牌桌数量",
    minEmptyTablePlaceholder: "请输入最少空位牌桌数量",
    minEmptyTableVerify: "最少空位牌桌数量不能为空！",
    matchName: "赛事名称",
    matchNamePlaceholder: "请输入赛事名称",
    matchNameVerify: "赛事名称不能为空！",
    matchDescription: "赛事说明",
    matchDescriptionPlaceholder: "请输入赛事说明",
    matchDescriptionVerify: "赛事说明不能为空！",
    prizePoolPlaceholder: "请输入保底奖池",
    prizePoolVerify: "保底奖池不能为空！",
    applyFee: "报名费",
    applyFeePlaceholder: "请输入报名费",
    applyFeeVerify: "报名费不能为空！",
    minStartMatchPeople: "最低开赛人数",
    minStartMatchPeoplePlaceholder: "请输入最低开赛人数",
    minStartMatchPeopleVerify: "最低开赛人数不能为空！",
    rebuyFee: "Rebuy费用",
    rebuyFeePlaceholder: "请输入Rebuy费用",
    rebuyFeeVerify: "Rebuy费用不能为空！",
    unionOwnerId: "联盟主ID",
    unionOwnerIdPlaceholder: "请输入联盟主ID",
    unionOwnerIdVerify: "联盟主ID不能为空！",
    unionName: "联盟名称",
    unionNamePlaceholder: "请输入联盟名称",
    unionNameVerify: "联盟名称不能为空！",
    clubId: "俱乐部ID",
    clubIdPlaceholder: "请输入俱乐部ID",
    clubIdVerify: "俱乐部ID不能为空！",
    clubName: "俱乐部名称",
    clubNamePlaceholder: "请输入俱乐部名称",
    clubNameVerify: "俱乐部名称不能为空！",
    playerId: "玩家ID",
    playerIdPlaceholder: "请输入玩家ID",
    playerIdVerify: "玩家ID不能为空！",
    playerName: "玩家昵称",
    playerNamePlaceholder: "请输入玩家昵称",
    playerNameVerify: "玩家昵称不能为空！",
    matchId: "赛事ID",
    matchIdPlaceholder: "请输入赛事ID",
    matchIdVerify: "赛事ID不能为空！",
    uid: "UID",
    uidPlaceholder: "请输入UID",
    uidVerify: "UID不能为空！",
    satelliteMatchMid: "卫星赛MID",
    satelliteMatchMidPlaceholder: "请输入卫星赛MID",
    satelliteMatchMidVerify: "卫星赛MID不能为空！",
    palyerOneId: "玩家1ID",
    palyerOneIdPlaceholder: "请输入玩家1ID",
    palyerOneIdVerify: "玩家1ID不能为空！",
    playerTwoId: "玩家2ID",
    playerTwoIdPlaceholder: "请输入玩家2ID",
    playerTwoIdVerify: "玩家2ID不能为空！",
    searchContent: "搜索内容",
    searchContentPlaceholder: "请输入搜索内容",
    searchContentVerify: "搜索内容不能为空！",
    propCusomeProportion: "道具消耗占比",
    propCusomeProportionPlaceholder: "请输入道具消耗占比",
    propCusomeProportionVerify: "道具消耗占比不能为空！",
    memberId: "会员ID",
    memberIdPlaceholder: "请输入会员ID",
    memberIdVerify: "会员ID不能为空！",
    proxyId: "代理ID",
    proxyIdPlaceholder: "请输入代理ID",
    proxyIdVerify: "代理ID不能为空！",
    proxyIdVerify1: "请输入3到64位字符！",
    kpokerPlayerId: "API玩家ID",
    kpokerPlayerIdPlaceholder: "请输入API玩家ID",
    kpokerPlayerIdVerify: "API玩家ID不能为空！",
    mainMatchMid: "主赛MID",
    mainMatchMidPlaceholder: "请输入主赛MID",
    mainMatchMidVerify: "主赛MID不能为空！",
    accountId: "账号ID",
    accountIdPlaceholder: "请输入账号ID",
    accountIdVerify: "账号ID不能为空！",
    superUnionId: "超盟ID",
    superUnionIdPlaceholder: "请输入超盟ID",
    superUnionIdVerify: "超盟ID不能为空！",
    superUnionName: "超盟名称",
    superUnionNamePlaceholder: "请输入超盟名称",
    superUnionNameVerify: "超盟名称不能为空！",
    superUnionIntroduce: "超盟介绍",
    superUnionIntroducePlaceholder: "请输入超盟介绍（限120字以内）",
    superUnionIntroduceVerify: "超盟介绍不能为空！",
    unionId: "联盟ID",
    unionIdPlaceholder: "请输入联盟ID",
    unionIdVerify: "联盟ID不能为空！",
    unionIntroduce: "联盟介绍",
    unionIntroducePlaceholder: "请输入联盟介绍（限120字以内）",
    unionIntroduceVerify: "联盟介绍不能为空！",
    gameId: "游戏ID",
    gameIdPlaceholder: "请输入游戏ID",
    gameIdVerify: "游戏ID不能为空！",
    gameAccount: "游戏账号",
    gameAccountPlaceholder: "请输入游戏账号",
    gameAccountVerify: "游戏账号不能为空！",
    backgroundAccount: "后台账号",
    backgroundAccountPlaceholder: "请输入后台账号",
    backgroundAccountVerify: "后台账号不能为空！",
    directAccount: "直营账号",
    directAccountPlaceholder: "请输入直营账号",
    directAccountVerify: "直营账号不能为空！",
    publishMatchTime: "开赛前多久发布",
    publishMatchTimePlaceholder: "请输入开赛前多久发布",
    publishMatchTimeVerify: "开赛前多久发布不能为空！",
    addonFee: "Addon费用",
    addonFeePlaceholder: "请输入Addon费用",
    addonFeeVerify: "Addon费用不能为空！",
    minTicket: "保底门票",
    minTicketPlaceholder: "请输入保底门票",
    minTicketVerify: "保底门票不能为空！",
    minPrizePool: "保底奖池",
    minPrizePoolPlaceholder: "请输入保底奖池",
    minPrizePoolVerify: "保底奖池不能为空！",
    batchApplyPeople: "批量报名人数",
    batchApplyPeoplePlaceholder: "请输入批量报名人数！",
    batchApplyPeopleVerify: "批量报名人数不能为空！",
    winnerProportion: "赢家比例",
    winnerProportionPlaceholder: "请输入赢家比例",
    winnerProportionVerify: "赢家比例不能为空！",
    loserProportion: "输家比例",
    loserProportionPlaceholder: "请输入输家比例",
    loserProportionVerify: "输家比例不能为空！",
    amount: "数量",
    amountPlaceholder: "请输入数量",
    amountVerify: "数量不能为空！",
    ipWhitelist: "IP白名单",
    ipWhitelistPlaceholder: "请输入IP白名单",
    ipWhitelistVerify: "IP白名单不能为空！",
    proxyAccount: "代理后台账号",
    proxyAccountPlaceholder: "请输入代理后台账号",
    proxyAccountVerify: "代理后台账号不能为空！",
    proxyAccountVerify1: "请输入4到16位数字或字母！",
    startPage: "起始页",
    startPagePlaceholder: "请输入起始页",
    startPageVerify: "起始页不能为空！",
    endPage: "结束页",
    endPagePlaceholder: "请输入结束页",
    endPageVerify: "结束页不能为空！",
    bonus: "奖金",
    bonusPlaceholder: "请输入奖金",
    bonusVerify: "奖金不能为空！",
    integral: "积分",
    integralPlaceholder: "请输入积分",
    integralVerify: "积分不能为空！",
    diamond: "钻石",
    diamondPlaceholder: "请输入钻石",
    diamondVerify: "钻石不能为空！",
    ticketId: "门票ID",
    ticketIdPlaceholder: "请输入门票ID",
    ticketIdVerify: "门票ID不能为空！",
    ticketName: "门票名称",
    ticketNamePlaceholder: "请输入门票名称",
    ticketNameVerify: "门票名称不能为空！",
    ticketValue: "门票价值",
    ticketValuePlaceholder: "请输入门票价值",
    ticketValueVerify: "门票价值不能为空！",
    taskName: "任务名称",
    taskNamePlaceholder: "请输入任务名称",
    taskNameVerify: "任务名称不能为空！",
    taskSort: "任务排序",
    taskSortPlaceholder: "请输入任务排序",
    taskSortVerify: "任务排序不能为空！",
    posterSort: "海报排序",
    posterSortPlaceholder: "请输入海报排序",
    posterSortVerify: "海报排序不能为空！",
    posterLinkUrl: "海报跳转链接",
    posterLinkUrlPlaceholder: "请输入海报跳转链接",
    posterLinkUrlVerify: "海报跳转链接不能为空！",
    customerLinkUrl: "客服链接",
    customerLinkUrlPlaceholder: "请输入客服链接",
    customerLinkUrlVerify: "客服链接不能为空！",
    ticketAmount: "门票数量",
    ticketAmountPlaceholder: "请输入门票数量",
    ticketAmountVerify: "门票数量不能为空！",
    playBoradHandNumber: "玩牌手数",
    playBoradHandNumberPlaceholder: "请输入玩牌手数",
    playBoradHandNumberVerify: "玩牌手数不能为空！",
    hitCount: "击中次数",
    hitCountPlaceholder: "请输入击中次数",
    hitCountVerify: "击中次数不能为空！",
    proportion: "比例",
    proportionPlaceholder: "请输入比例",
    proportionVerify: "比例不能为空！",
    proportionVerify1: "比例必须大于0！",
    usdt: "USDT",
    uPlaceholder: "请输入U",
    uVerify: "U不能为空！",
    uVerify1: "U必须大于0！",
    taskId: "任务ID",
    taskIdPlaceholder: "请输入任务ID",
    taskIdVerify: "任务ID不能为空！",
    derivativeInitiatorOrReceiverId: "倒分发起者或接收者ID",
    derivativeInitiatorOrReceiverIdPlaceholder: "请输入倒分发起者或接收者ID",
    derivativeInitiatorOrReceiverIdVerify: "倒分发起者或接收者ID不能为空！",
    derivativeInitiatorId: "倒分发起者ID",
    derivativeInitiatorIdPlaceholder: "请输入倒分发起者ID",
    derivativeInitiatorIdVerify: "倒分发起者ID不能为空！",
    derivativeReceiverId: "倒分接收者ID",
    derivativeReceiverIdPlaceholder: "请输入倒分接收者ID",
    derivativeReceiverIdVerify: "倒分接收者ID不能为空！",
    dayLossLimit: "日亏损限制",
    dayLossLimitPlaceholder: "请输入日亏损限制",
    dayLossLimitVerify: "日亏损限制不能为空！",
    dayLossLimitQuota: "日亏损限制额度",
    dayLossLimitQuotaPlaceholder: "请输入日亏损限制额度",
    dayLossLimitQuotaVerify: "日亏损限制额度不能为空！",
    dayRemainingRuota: "日剩余额度",
    dayRemainingRuotaPlaceholder: "请输入日剩余额度",
    dayRemainingRuotaVerify: "日剩余额度不能为空！",
    weekLossLimit: "周亏损限制",
    weekLossLimitPlaceholder: "请输入周亏损限制",
    weekLossLimitVerify: "周亏损限制不能为空！",
    weekLossLimitRuota: "周亏损限制额度",
    weekLossLimitRuotaPlaceholder: "请输入周亏损限制额度",
    weekLossLimitRuotaVerify: "周亏损限制额度不能为空！",
    weekRemainingRuota: "周剩余额度",
    weekRemainingRuotaPlaceholder: "请输入周剩余额度",
    weekRemainingRuotaVerify: "周剩余额度不能为空！",
    callbackAddress: "回调地址",
    callbackAddressPlaceholder: "请输入回调地址",
    callbackAddressVerify: "回调地址不能为空！",
    title: "标题",
    titlePlaceholder: "请输入标题",
    titleVerify: "标题不能为空！",
    versionNumber: "版本号",
    versionNumberPlaceholder: "请输入版本号",
    versionNumberVerify: "版本号不能为空！",
    ratio: "比例",
    ratioPlaceholder: "请输入比例",
    ratioVerify: "比例不能为空！",
    gamblingPartyNumber: "牌局人数",
    gamblingPartyNumberPlaceholder: "请输入牌局人数",
    gamblingPartyNumberVerify: "牌局人数不能为空！",
    cisternaBasalis: "底池",
    cisternaBasalisPlaceholder: "请输入底池",
    cisternaBasalisVerify: "底池不能为空！",

    // 下拉框
    unionAccount: "超盟/联盟账号",
    unionAccountPlaceholder: "请选择超盟/联盟账号",
    unionAccountVerify: "请选择超盟/联盟账号！",
    roundTime: "每轮时长",
    roundTimePlaceholder: "请选择每轮时长",
    roundTimeVerify: "请选择每轮时长！",
    roundAmount: "轮数",
    roundAmountPlaceholder: "请选择轮数",
    roundAmountVerify: "请选择轮数！",
    startTime: "开始时间",
    startTimePlaceholder: "请选择开始时间",
    startTimeVerify: "请选择开始时间！",
    timeRange: "时间范围",
    timeRangePlaceholder: "请选择时间范围",
    timeRangeVerify: "请选择时间范围！",
    posterImage: "海报图片",
    posterImagePlaceholder: "请选择海报图片",
    posterImageVerify: "请选择海报图片！",
    thumbnail: "小图",
    thumbnailPlaceholder: "请选择小图",
    thumbnailVerify: "请选择小图！",
    insuranceDivide: "保险分成",
    insuranceDividePlaceholder: "请选择保险分成",
    insuranceDivideVerify: "请选择保险分成！",
    cowboyDivide: "牛仔分成",
    cowboyDividePlaceholder: "请选择牛仔分成",
    cowboyDivideVerify: "请选择牛仔分成！",
    realTimeRecord: "即时战绩",
    realTimeRecordPlaceholder: "请选择即时战绩",
    realTimeRecordVerify: "请选择即时战绩！",
    handCardNumber: "手牌数量",
    handCardNumberPlaceholder: "请选择手牌数量",
    handCardNumberVerify: "请选择手牌数量！",
    levelRange: "级别范围",
    levelRangePlaceholder: "请选择级别范围",
    levelRangeVerify: "请选择级别范围！",
    foreword: "前注",
    forewordPlaceholder: "请选择前注",
    forewordVerify: "请选择前注！",
    forewordRange: "前注范围",
    forewordRangePlaceholder: "请选择前注范围",
    forewordRangeVerify: "请选择前注范围！",
    bringRange: "带入范围",
    bringRangePlaceholder: "请选择带入范围",
    bringRangeVerify: "请选择带入范围！",
    serviceFee: "服务费",
    serviceFeePlaceholder: "请选择服务费",
    serviceFeeVerify: "请选择服务费！",
    serviceFeeCap: "服务费封顶",
    serviceFeeCapPlaceholder: "请选择服务费封顶",
    serviceFeeCapVerify: "请选择服务费封顶！",
    thinkTime: "思考时间",
    thinkTimePlaceholder: "请选择思考时间",
    thinkTimeVerify: "请选择思考时间！",
    delayTime: "自动延时次数",
    delayTimePlaceholder: "请选择自动延时次数",
    delayTimeVerify: "请选择自动延时次数！",
    peopleNumber: "人数",
    peopleNumberPlaceholder: "请选择人数",
    peopleNumberVerify: "请选择人数！",
    time: "时间",
    timePlaceholder: "请选择时间",
    timeVerify: "请选择时间！",
    gameMode: "游戏模式",
    gameModePlaceholder: "请选择游戏模式",
    gameModeVerify: "请选择游戏模式！",
    operationOrder: "操作顺序",
    operationOrderPlaceholder: "请选择操作顺序",
    operationOrderVerify: "请选择操作顺序！",
    multiple: "倍数",
    multiplePlaceholder: "请选择倍数",
    multipleVerify: "请选择倍数！",
    multipleRange: "倍数范围",
    multipleRangePlaceholder: "请选择倍数范围",
    multipleRangeVerify: "请选择倍数范围！",
    minEntryPoint: "最低入局",
    minEntryPointPlaceholder: "请选择最低入局",
    minEntryPointVerify: "请选择最低入局！",
    blindType: "盲注结构",
    blindTypePlaceholder: "请选择盲注结构",
    blindTypeVerify: "请选择盲注结构！",
    type: "类型",
    typePlaceholder: "请选择类型",
    typeVerify: "请选择类型！",
    rebuyTime: "Rebuy次数",
    rebuyTimePlaceholder: "请选择Rebuy次数",
    rebuyTimeVerify: "请选择Rebuy次数！",
    rebuyChip: "Rebuy筹码",
    rebuyChipPlaceholder: "请选择Rebuy筹码",
    rebuyChipVerify: "请选择Rebuy筹码！",
    initChip: "初始筹码",
    initChipPlaceholder: "请选择初始筹码",
    initChipVerify: "请选择初始筹码！",
    blindTimeApplyStart: "涨盲时间（截至报名前）",
    blindTimeApplyStartPlaceholder: "请选择涨盲时间",
    blindTimeApplyStartVerify: "请选择涨盲时间！",
    blindTimeApplyEnd: "涨盲时间（截至报名后）",
    blindTimeApplyEndPlaceholder: "请选择涨盲时间",
    blindTimeApplyEndVerify: "请选择涨盲时间！",
    blindTimeFinally: "涨盲时间（决赛桌）",
    blindTimeFinallyPlaceholder: "请选择涨盲时间",
    blindTimeFinallyVerify: "请选择涨盲时间！",
    deadlineApply: "截至报名",
    deadlineApplyPlaceholder: "请选择截至报名",
    deadlineApplyVerify: "请选择截至报名！",
    singleSeatNumber: "单桌座位数",
    singleSeatNumberPlaceholder: "请选择单桌座位数",
    singleSeatNumberVerify: "请选择单桌座位数！",
    prizPooAllocation: "奖池分配",
    prizPooAllocationPlaceholder: "请选择奖池分配",
    prizPooAllocationVerify: "请选择奖池分配！",
    publishType: "发布类型",
    publishTypePlaceholder: "请选择发布类型",
    publishTypeVerify: "请选择发布类型！",
    startMatchTime: "开赛时间",
    startMatchTimePlaceholder: "请选择开赛时间",
    startMatchTimeVerify: "请选择开赛时间！",
    startMatchTimeRange: "开赛日期范围（最多30天）",
    startMatchTimeRangePlaceholder: "请选择开赛日期范围",
    startMatchTimeRangeVerify: "请选择开赛日期范围！",
    startMatchTimeWeek: "每周几开赛",
    startMatchTimeWeekPlaceholder: "请选择每周几开赛",
    startMatchTimeWeekVerify: "请选择每周几开赛！",
    belongUnion: "所属联盟",
    belongUnionPlaceholder: "请选择所属联盟",
    belongUnionVerify: "请选择所属联盟！",
    belongClub: "所属俱乐部",
    belongClubPlaceholder: "请选择所属俱乐部",
    belongClubVerify: "请选择所属俱乐部！",
    belongProxy: "所属代理",
    belongProxyPlaceholder: "请选择所属代理",
    belongProxyVerify: "请选择所属代理！",
    role: "角色",
    rolePlaceholder: "请选择角色",
    roleVerify: "请选择角色！",
    gameType: "游戏类型",
    gameTypePlaceholder: "请选择游戏类型",
    gameTypeVerify: "请选择游戏类型！",
    playingType: "玩法",
    playingTypePlaceholder: "请选择玩法",
    playingTypeVerify: "请选择玩法！",
    sort: "排序",
    sortPlaceholder: "请选择排序",
    sortVerify: "请选择排序！",
    searchType: "搜索类型",
    searchTypePlaceholder: "请选择搜索类型",
    searchTypeVerify: "请选择搜索类型！",
    blindLevel: "盲注级别",
    blindLevelPlaceholder: "请选择盲注级别",
    blindLevelVerify: "请选择盲注级别！",
    belongGamble: "牌局所属",
    belongGamblePlaceholder: "请选择牌局所属",
    belongGambleVerify: "请选择牌局所属！",
    matchStatus: "赛事状态",
    matchStatusPlaceholder: "请选择赛事状态",
    matchStatusVerify: "请选择赛事状态！",
    union: "联盟",
    unionPlaceholder: "请选择联盟",
    unionVerify: "请选择联盟！",
    status: "状态",
    statusPlaceholder: "请选择状态",
    statusVerify: "请选择状态！",
    bonusStatus: "奖金状态",
    bonusStatusPlaceholder: "请选择奖金状态",
    bonusStatusVerify: "请选择奖金状态！",
    squidValue: "鱿鱼价值",
    squidValuePlaceholder: "请选择鱿鱼价值",
    squidValueVerify: "请选择鱿鱼价值！",
    squidMode: "鱿鱼模式",
    squidModePlaceholder: "请选择鱿鱼模式",
    squidModeVerify: "请选择鱿鱼模式！",
    detectionHandNumber: "本局开始检测手数",
    detectionHandNumberPlaceholder: "请选择本局开始检测手数",
    detectionHandNumberVerify: "请选择本局开始检测手数！",
    currentEntryPoolStandard: "本局入池标准",
    currentEntryPoolStandardPlaceholder: "请选择本局入池标准",
    currentEntryPoolStandardVerify: "请选择本局入池标准！",
    sitEntryPoolRate: "可坐下入池率",
    sitEntryPoolRatePlaceholder: "请选择可坐下入池率",
    sitEntryPoolRateVerify: "请选择可坐下入池率！",
    leaveCondition: "离开条件",
    leaveConditionPlaceholder: "请选择离开条件",
    leaveConditionVerify: "请选择离开条件！",
    boomType: "炸弹类型",
    boomTypePlaceholder: "请选择炸弹类型",
    boomTypeVerify: "请选择炸弹类型！",
    boomRandomPoolBetRange: "炸弹彩池随机底注范围",
    boomRandomPoolBetRangePlaceholder: "请选择炸弹彩池随机底注范围",
    boomRandomPoolBetRangeVerify: "请选择炸弹彩池随机底注范围！",
    triggerType: "触发类型",
    triggerTypePlaceholder: "请选择触发类型",
    triggerTypeVerify: "请选择触发类型！",
    profitTrigger: "盈利触发",
    profitTriggerPlaceholder: "请选择盈利触发",
    profitTriggerVerify: "请选择盈利触发！",
    lotteryPoolPrize: "彩池奖金",
    lotteryPoolPrizePlaceholder: "请选择彩池奖金",
    lotteryPoolPrizeVerify: "请选择彩池奖金！",
    autoUnloadNumber: "自动卸码数量",
    autoUnloadNumberPlaceholder: "请选择自动卸码数量",
    autoUnloadNumberVerify: "请选择自动卸码数量！",
    autoStartPeople: "自动开始人数",
    autoStartPeoplePlaceholder: "请选择自动开始人数",
    autoStartPeopleVerify: "请选择自动开始人数！",
    minSubstitution: "最小带入",
    minSubstitutionPlaceholder: "请选择最小带入",
    minSubstitutionVerify: "请选择最小带入！",
    currentGambleTable: "当前牌桌",
    currentGambleTablePlaceholder: "请选择当前牌桌",
    currentGambleTableVerify: "请选择当前牌桌！",
    dataType: "数据类型",
    dataTypePlaceholder: "请选择数据类型",
    dataTypeVerify: "请选择数据类型！",
    date: "日期",
    datePlaceholder: "请选择日期",
    dateVerify: "请选择日期！",
    competition: "赛事",
    competitionPlaceholder: "请选择赛事",
    competitionVerify: "请选择赛事！",
    club: "俱乐部",
    clubPlaceholder: "请选择俱乐部",
    clubVerify: "请选择俱乐部！",
    proxy: "代理",
    proxyPlaceholder: "请选择代理",
    proxyVerify: "请选择代理！",
    accountType: "账号类型",
    accountTypePlaceholder: "请选择账号类型",
    accountTypeVerify: "请选择账号类型！",
    matchCnfig: "赛事配置",
    matchCnfigPlaceholder: "请选择赛事配置",
    matchCnfigVerify: "请选择赛事配置！",
    addonChip: "Addon筹码",
    addonChipPlaceholder: "请选择Addon筹码",
    addonChipVerify: "请选择Addon筹码！",
    nextMatch: "下一轮比赛",
    nextMatchPlaceholder: "请选择下一轮比赛",
    nextMatchVerify: "请选择下一轮比赛！",
    ticket: "门票",
    ticketPlaceholder: "请选择门票",
    ticketVerify: "请选择门票！",
    award: "奖励",
    awardPlaceholder: "请设置奖励",
    awardVerify: "请设置奖励！",
    awardPlaceholder1: "请设置第{}名奖励",
    awardVerify1: "请设置第{}名奖励！",
    expirationTime: "过期时间",
    expirationTimePlaceholder: "请选择过期时间",
    expirationTimeVerify: "请选择过期时间！",
    matchType: "比赛类型",
    matchTypePlaceholder: "请选择比赛类型",
    matchTypeVerify: "请选择比赛类型！",
    supportMatch: "支持比赛",
    supportMatchPlaceholder: "请选择支持比赛",
    supportMatchVerify: "请选择支持比赛！",
    managementUnionPlaceholder: "请选择管理联盟",
    managementUnionVerify: "请选择管理联盟！",
    proxyPlatformTokenType: "代理平台币类型",
    proxyPlatformTokenTypePlaceholder: "请选择代理平台币类型",
    proxyPlatformTokenTypeVerify: "请选择代理平台币类型！",
    walletType: "钱包类型",
    walletTypePlaceholder: "请选择钱包类型",
    walletTypeVerify: "请选择钱包类型！",
    gameMatchCnfig: "{}配置",
    gameMatchCnfigPlaceholder: "请选择{}配置",
    gameMatchCnfigVerify: "请选择{}配置！",
    taskMatchCnfig: "任务配置",
    taskMatchCnfigPlaceholder: "请选择任务配置",
    taskMatchCnfigVerify: "请选择任务配置！",
    showType: "展示类型",
    showTypePlaceholder: "请选择展示类型",
    showTypeVerify: "请选择展示类型！",
    displayCurrency: "显示货币",
    displayCurrencyPlaceholder: "请选择显示货币",
    displayCurrencyVerify: "请选择显示货币！",
    activityType: "活动类型",
    activityTypePlaceholder: "请选择活动类型",
    activityTypeVerify: "请选择活动类型！",
    configFile: "配置文件",
    configFilePlaceholder: "请选择配置文件",
    configFileVerify: "请选择配置文件！",
    bonusType: "Bonus类型",
    bonusTypePlaceholder: "请选择Bonus类型",
    bonusTypeVerify: "请选择Bonus类型！",
    accountRole: "账号角色",
    accountRolePlaceholder: "请选择账号角色",
    accountRoleVerify: "请选择账号角色！",
    unionType: "联盟类型",
    unionTypePlaceholder: "请选择联盟类型",
    unionTypeVerify: "请选择联盟类型！",
    registerChannel: "注册渠道",
    registerChannelPlaceholder: "请选择注册渠道",
    registerChannelVerify: "请选择注册渠道！",
    customerType: "客服类型",
    customerTypePlaceholder: "请选择客服类型",
    customerTypeVerify: "请选择客服类型！",
    channel: "渠道",
    channelPlaceholder: "请选择渠道",
    channelVerify: "请选择渠道！",
    signaturePackage: "签名包",
    signaturePackagePlaceholder: "请选择签名包",
    signaturePackageVerify: "请选择签名包！",
    area: "地区",
    areaPlaceholder: "请选择地区",
    areaVerify: "请选择地区！",
    clubPointsRatio: "俱乐部积分比例",
    clubPointsRatioPlaceholder: "请选择俱乐部积分比例",
    clubPointsRatioVerify: "请选择俱乐部积分比例！",
    initialBet: "初始前注",
    initialBetPlaceholder: "请选择初始前注",
    initialBetVerify: "请选择初始前注！",
    littleBlindBet: "小盲前注",
    littleBlindBetPlaceholder: "请选择小盲前注",
    littleBlindBetVerify: "请选择小盲前注！",
    registerSource: "注册来源",
    registerSourcePlaceholder: "请选择注册来源",
    registerSourceVerify: "请选择注册来源！",

    // 后缀
    levelFix: "（大盲/前注/底分）",
    initChipFix: "（x初始筹码）",
    levelsuFix: "（级别）",
    ipWhitelistFix: "（多个ip使用 ',' 分隔，最多20个）",
    everyDayTimeFix: "（每天几点）",
    minuteFix: "（分钟）",
    initChipFix: "（x初始筹码）",
    tenMultipleFix: "（10的整数倍）",
    counterDeductionFix: "（需从柜台预扣积分）",

    // 其他
    loginTitle: "A1 Poker超盟/联盟后台",
    superUnionTitle: "A1 Poker超盟后台",
    unionTitle: "A1 Poker联盟后台",
    directUnionTitle: "Ace1 Poker总代理后台",
    kpokerUnionTitle: "Ace1 Poker API版本总代理后台",
    superUnionMaster: "超盟主",
    superUnionVip: "超级管理员",
    superUnionAdmin: "超盟管理员",
    superUnionAdminService: "超盟客服",
    superUnionAdminFinance: "超盟商务",
    superUnionAdminManagement: "超盟管理层",
    unionMaster: "联盟主",
    unionVip: "超级管理员",
    unionAdmin: "联盟管理员",
    unionAdminService: "联盟客服",
    directUnionMaster: "直营联盟主",
    directUnionVip: "超级管理员",
    directUnionAdmin: "直营联盟管理员",
    directUnionAdminService: "直营联盟客服",
    kpokerUnionMaster: "API联盟主",
    kpokerUnionVip: "超级管理员",
    kpokerUnionAdmin: "API联盟管理员",
    kpokerUnionAdminService: "API联盟客服",
    kpokerUnionAdminAccount: "API联盟看账",
    cancel: "取消",
    confirm: "确定",
    delete: "删除",
    edit: "编辑",
    save: "保存",
    search: "搜索",
    submit: "提交",
    update: "更新",
    view: "查看",
    add: "添加",
    record: "记录",
    login: "登陆",
    lastStep: "上一步",
    phoneAccountLogin: "手机号登陆",
    emailAccountLogin: "邮箱/账号登陆",
    switchAccount: "切换账号",
    logout: "退出登录",
    query: "查询",
    reset: "重置",
    exportExcel: "导出到Excel",
    endTime: "结束时间",
    updateTime: "更新时间",
    addTime: "添加时间",
    registerTime: "注册时间",
    lastLoginTime: "最后登录时间",
    lastPlayCardTime: "最后玩牌时间",
    operation: "操作",
    counterPoint: "柜台积分",
    counterDiamond: "柜台钻石",
    gain: "利润",
    pvpProfitSum: "玩家PVP游戏盈亏",
    insProfitSum: "玩家保险盈亏",
    cbProfitSum: "玩家牛仔盈亏",
    gamePepoleNumber: "游戏人数",
    matchSum: "牌局数",
    player: "玩家",
    lower: "下级",
    data: "数据",
    balance: "余额",
    today: "今日",
    thisWeek: "本周",
    lastWeek: "上周",
    historyTotal: "历史总计",
    totalIncome: "总收益",
    insurance: "保险",
    accountName: "账号昵称",
    addAccount: "添加账号",
    editAccount: "编辑账号",
    integralBalance: "积分余额",
    remark: "备注",
    distributionSource: "分销来源",
    distributionAmount: "分销额",
    amountLimit: "数额",
    superProxy: "超级代理",
    superProxyId: "超级代理ID",
    superProxyName: "超级代理昵称",
    oneProxy: "一级代理",
    oneProxyId: "一级代理ID",
    oneProxyName: "一级代理昵称",
    twoProxy: "二级代理",
    twoProxyId: "二级代理ID",
    twoProxyName: "二级代理昵称",
    threeProxy: "三级代理",
    threeProxyId: "三级代理ID",
    threeProxyName: "三级代理昵称",
    fourProxy: "四级代理",
    fourProxyId: "四级代理ID",
    fourProxyName: "四级代理昵称",
    diamondAmount: "钻石数量",
    integralAmount: "积分数量",
    totalCusome: "总消耗",
    cusomeAmount: "消耗数量",
    cusomeOrigin: "消耗来源",
    origin: "来源",
    gambleId: "牌局ID",
    level: "级别",
    startCosume: "开局消耗",
    exchangeIntegral: "兑换积分",
    distribution: "分销",
    importMatchConfig: "导入赛事配置",
    applyPeopleNumber: "报名人数",
    applyPeopleTime: "报名人次",
    rebuyHand: "rebuy手数",
    addonHand: "addon手数",
    enterFee: "参赛费",
    bonusPayment: "奖金发放",
    profit: "盈利",
    winnerPeople: "钱圈人数",
    serviceRatio: "服务费比例",
    addonTime: "addon次数",
    matchDurationTime: "比赛时长",
    createTime: "创建时间",
    isClone: "是否克隆比赛",
    isRoomCowboy: "房间内Cowboy",
    disableSimulator: "禁用模拟器",
    satelliteGames: "卫星赛",
    currentBlind: "当前盲注",
    blindTimeStart: "涨盲时间",
    endApplyLevel: "截至报名级别",
    nlh: "NLH",
    squid: "SQUID",
    super: "SUPER",
    plo: "PLO",
    plo4: "PLO4",
    plo5: "PLO5",
    plo6: "PLO6",
    aof: "AOF",
    six: "6+",
    mtt: "MTT",
    ofc: "OFC",
    cowboy: "COWBOY",
    squid: "SQUID",
    super: "SUPER",
    nhlInsurance: "保险_NLH",
    squidInsurance: "保险_SQUID",
    superInsurance: "保险_SUPER",
    ploInsurance: "保险_PLO",
    aofInsurance: "保险_AOF",
    sixInsurance: "保险_6+",
    mttInsurance: "保险_MTT",
    ofcInsurance: "保险_OFC",
    cowboyInsurance: "保险_COWBOY",
    nlhFee: "服务费_NLH",
    squidFee: "服务费_SQUID",
    superFee: "服务费_SUPER",
    ploFee: "服务费_PLO",
    aofFee: "服务费_AOF",
    sixFee: "服务费_6+",
    mttFee: "服务费_MTT",
    ofcFee: "服务费_OFC",
    cowboyFee: "服务费_COWBOY",
    nlhProfit: "玩家盈亏_NLH",
    squidProfit: "玩家盈亏_SQUID",
    superProfit: "玩家盈亏_SUPER",
    ploProfit: "玩家盈亏_PLO",
    aofProfit: "玩家盈亏_AOF",
    sixProfit: "玩家盈亏_6+",
    mttProfit: "玩家盈亏_MTT",
    ofcProfit: "玩家盈亏_OFC",
    cowboyProfit: "玩家盈亏_COWBOY",
    nlhDeductFee: "交上扣除_服务费_NLH",
    squidDeductFee: "交上扣除_服务费_SQUID",
    superDeductFee: "交上扣除_服务费_SUPER",
    ploDeductFee: "交上扣除_服务费_PLO",
    aofDeductFee: "交上扣除_服务费_AOF",
    sixDeductFee: "交上扣除_服务费_6+",
    mttDeductFee: "交上扣除_服务费_MTT",
    ofcDeductFee: "交上扣除_服务费_OFC",
    cowboyDeductFee: "交上扣除_服务费_COWBOY",
    nlhDeductInsurance: "交上扣除_保险_NLH",
    squidDeductInsurance: "交上扣除_保险_SQUID",
    superDeductInsurance: "交上扣除_保险_SUPER",
    ploDeductInsurance: "交上扣除_保险_PLO",
    ofcDeductInsurance: "交上扣除_保险_OFC",
    sixDeductInsurance: "交上扣除_保险_6+",
    mttDeductInsurance: "交上扣除_保险_MTT",
    aofDeductInsurance: "交上扣除_保险_AOF",
    cowboyDeductInsurance: "交上扣除_保险_COWBOY",
    openNumberStatistics: "开局数_NLH/6+/PLO/OFC/MTT/CB/AOF/SQUID/SUPER",
    joinPeopleNumberStatistics: "参与人数_NLH/6+/PLO/OFC/MTT/CB/AOF/SQUID/SUPER",
    handNumberStatistics: "手牌数_NLH/6+/PLO/OFC/MTT/CB/AOF/SQUID/SUPER",
    playerProfitStatistics: "玩家盈亏_NLH/6+/PLO/OFC/MTT/CB/AOF/SQUID/SUPER",
    serviceFeeStatistics: "服务费_NLH/6+/PLO/OFC/MTT/CB/AOF/SQUID/SUPER",
    insuranceStatistics: "保险_NLH/6+/PLO/OFC/MTT/CB/AOF/SQUID/SUPER",
    insuranceBuyInStatistics: "保险买入明细_NLH/6+/PLO/OFC/MTT/CB/AOF/SQUID/SUPER",
    joinTableNumberStatistics: "参与局数_NLH/6+/PLO/OFC/MTT/CB/AOF/SQUID/SUPER",
    profitStatistics: "盈利_NLH/6+/PLO/OFC/MTT/CB/AOF/SQUID/SUPER",
    competitionType: "赛事类型",
    matchApplyFee: "报名/服务费（赛事）",
    rebootApplyFee: "报名/服务费（重进）",
    repurchaseApplyFee: "报名/服务费（重购）",
    buyMoreApplyFee: "报名/服务费（增购）",
    seatNumber: "座位数",
    totalSeatNumber: "总桌数",
    applyNumber: "报名次数",
    rebootNumber: "重购人数",
    rebootTime: "重购次数",
    repurchaseNumber: "重进人数",
    repurchaseTime: "重进次数",
    buyMoreTime: "增购次数",
    totalApplyFee: "总报名费",
    totalServiceFee: "总服务费",
    ticketApply: "门票报名数",
    prizePool: "奖池",
    matchSeparate: "赛事分成",
    matchIncome: "赛事收益",
    order: "排名",
    prizeTicketNumber: "奖励门票数",
    chipNumber: "筹码数",
    matchTime: "参赛次数",
    apply: "报名",
    repurchase: "重进",
    reboot: "重购",
    buyMore: "增购",
    satelliteName: "卫星赛名称",
    mainMatchName: "主赛名称",
    statusUpdateTime: "状态更新时间",
    superPlayerId: "上级玩家ID",
    superPlayerName: "上级玩家昵称",
    lowerCounterTotalIntegral: "下级柜台总积分",
    lowerProxyNumber: "下线代理数",
    lowerPlayerNumber: "下线玩家数",
    handNumber: "手数",
    gameProfit: "游戏盈亏",
    serviceFeeContribution: "服务费贡献",
    insuranceContribution: "保险贡献",
    insuranceInvestmentAmount: "保险投注额",
    cowboyContribution: "牛仔贡献",
    cowboyBettingAmount: "牛仔投注额",
    loginTime: "登陆时间",
    clientVersion: "客户端版本",
    channelNumber: "子渠道号",
    networkType: "网络类型",
    systemYype: "系统类型",
    unitType: "设备型号",
    loginIp: "登录IP",
    imei: "设备IMEI",
    macAddress: "客户端MAC地址",
    openRole: "开局角色",
    squidGame: "鱿鱼游戏",
    sushiGame: "寿司游戏",
    openInsurance: "开启保险",
    profit: "盈亏",
    insuranceProfit: "保险盈亏",
    buyIn: "买入",
    insureTimes: "投保次数",
    sumInsured: "投保额",
    betAmount: "下注额",
    rank: "名次",
    belongUnionId: "所属联盟ID",
    belongUnionName: "所属联盟名称",
    belongClubId: "所属俱乐部ID",
    belongClubName: "所属俱乐部名称",
    belongProxyId: "所属代理ID",
    belongProxyName: "所属代理名称",
    playerDiamnd: "玩家钻石",
    totalProfit: "总盈亏",
    totalInsurance: "总保险",
    joinTableNumber: "参与局数",
    playerProfit: "玩家盈亏",
    cowboysProfit: "牛仔盈亏",
    configId: "配置ID",
    autoUnloadCode: "自动卸码",
    colorPool: "27彩池",
    bombMode: "Bomb模式",
    entryPoolStandard: "入池标准",
    lame: "癞子",
    insuranceMode: "保险模式",
    blind: "补盲",
    straddle: "强制Straddle",
    showHands: "强制亮牌",
    openCard: "顺序开牌",
    randomSeat: "随机座位",
    ipAndGpsLimit: "IP&GPS限制",
    closeChat: "关闭聊天",
    autoRoomReconstruction: "自动重建房间",
    squidDisabledTips: "Rathole，CallTime，寿司游戏开启时不可用",
    sushiDisabledTips: "Bomb模式，鱿鱼游戏开启时不可用",
    ratholeDisabledTips: "鱿鱼游戏开启时不可用",
    callTimeDisabledTips: "鱿鱼游戏开启时不可用",
    bombDisabledTips: "寿司游戏开启时不可用",
    superAndSushiDisabledTips: "夯场模式和寿司游戏不可同时开启",
    playMethod: "玩法",
    todayOpenTable: "当日已开桌",
    gambleProgress: "进行中牌桌",
    openTable: "已开始空桌",
    notBeginTable: "未开始牌桌",
    isAutoOpenTable: "是否自动开桌",
    gambleOpenTime: "牌局开始时间",
    totalHand: "总手数",
    gambleStatus: "牌局状态",
    currentPeopleNumber: "在玩人数/座位",
    gambleType: "牌局玩法",
    inClub: "所在俱乐部",
    inUnion: "所在联盟",
    inSuperUnion: "所在超盟",
    bought: "已买入",
    poolEntryRate: "入池率",
    gameNickname: "游戏昵称",
    betAmount: "注单金额",
    totalBuyIn: "总买入",
    insuranceBuyamount: "保险购买额",
    serviceFeesProportion: "服务费占比分成",
    insuranceProportion: "保险占比分成",
    joinNumber: "参与人数",
    propConsume: "道具消耗",
    palyerTotalProfit: "玩家总盈亏",
    cowboyBetAmount: "牛仔下注额",
    activityBouns: "活动奖金",
    activityCost: "活动成本",
    propsConsumeIntegral: "道具消耗积分",
    cowboysProportion: "牛仔占比分成",
    totalProportion: "总收益",
    totalGaveIn: "总交上",
    palyerNumber: "玩家数量",
    allowCreateTable: "允许创建牌局",
    activityId: "活动ID",
    currentRound: "当前轮次",
    totalRound: "总轮次",
    singlePrize: "单轮奖励",
    totalPrize: "总奖励",
    alreadyWinnPeople: "已获奖人数",
    alreadyPrize: "已获奖励",
    round: "轮次",
    currentRoundEndTime: "该轮结束时间",
    winPrizeTime: "中奖时间",
    winPrizePlayerId: "中奖玩家ID",
    winrizePlayerName: "中奖玩家昵称",
    cardType: "牌型",
    poster: "海报",
    clubOwnerId: "俱乐部主ID",
    clubOwnerName: "俱乐部主昵称",
    joinUnionTime: "加入联盟时间",
    proxyAmount: "代理数量",
    cowboyBetAmount: "牛仔投注次数",
    luckycard: "Luckycard",
    jackpot: "Jackpot",
    ipLoginCount: "同IP登录次数",
    equipmentLoginCount: "同设备登录次数",
    tableCount: "同桌次数",
    tableOdd: "同桌率",
    poolCount: "同池次数",
    poolOdd: "同池率",
    poolBetCount: "同池再加注次数",
    dubiousGambleCount: "可疑牌局数",
    playerOneName: "玩家1昵称",
    playerTwoName: "玩家2昵称",
    unionOwnerName: "联盟主昵称",
    joinSuperUnionTime: "加入超盟时间",
    clubNumber: "俱乐部数量",
    allowCreateFreeMatch: "允许创建免费赛/保底赛",
    clubApplicationRecord: "俱乐部申请记录",
    proxyApplicationRecord: "代理申请记录",
    clubPeopleNumber: "俱乐部人数",
    applicationTime: "申请时间",
    messageContent: "消息内容",
    serviceFeeZC: "服务费占成",
    insuranceZC: "保险占成",
    cowboyZC: "牛仔占成",
    currentPrizePool: "当前奖池",
    currentLunckyCard: "当前幸运牌",
    rechargePrizePool: "充值奖池",
    userDataQuery: "用户数据筛查",
    hitGambleStartDate: "击中牌局开始日期",
    hitDate: "击中时间",
    handId: "手数ID",
    winAmount: "中奖金额",
    thatTimeAward: "当时奖池",
    reissue: "补发",
    noReissue: "不补发",
    activityDescription: "活动说明",
    activityDescription1: "1.系统每天再设置的时候随机刷新两个数字的手牌，当玩家手牌为随机的这两个数字（PLO为组成最终牌型的两张手牌）并且赢得底池时玩家可以额活动说明外活动奖励；",
    activityDescription2: "2.奖池来源是从底池达到10BB的手牌进行抽取；",
    activityDescription3: "3.玩家完成对应的次数后获得相应的奖励；",
    serviceFeeAndBonus: "服务费&奖金",
    blindBet: "盲注",
    prizeCount: "奖励(AOF次数乘3,PLO次数乘2)",
    prizeTwoCount: "2次",
    prizeTenCount: "5次",
    prizeType3: "10次",
    activitySwitch: "活动开关",
    effectiveTomorrow: "明日生效",
    functionDescription: "功能说明",
    winCondition: "中奖条件",
    winCondition1: "1.游戏类型NLH，PLO4，PLO5，PLO6",
    winCondition2: "2. 输家必须有最小的符合手牌",
    winCondition3: "3.发牌时至少4名玩家拿到手牌，有效底池大于等于20BB；",
    winCondition4: "4. 成牌必须使用两张手牌组成成牌。葫芦时至少有一张手牌为A；四条牌时，需要四条必须由手上的1对所凑成。",
    minHandCard: "最小符合手牌",
    handCardType1: "NLH：AAAJJ",
    handCardType2: "PLO4：KKKK2",
    handCardType3: "PLO5：AAAA四条",
    handCardType4: "PLO6：56789同花顺",
    serviceFeeAndBonusRatio: "服务费&奖金比例",
    underdog: "输家",
    winner: "赢家",
    otherPlayer: "其余玩家",
    createPoster: "创建海报",
    editPoster: "编辑海报",
    suggestHeightWidth: "建议尺寸：宽{}px；高{}px",
    suggestSize: "建议大小：{}MB以内",
    createUnion: "创建联盟",
    currentSuperUnionServiceFeeContribution: "本超盟服务费贡献比例",
    traditionMode: "传统模式",
    evMode: "EV模式",
    sendIntegral: "发放积分",
    recycleIntegral: "回收积分",
    sendDiamond: "发放钻石",
    recycleDiamond: "回收钻石",
    sendChip: "发放筹码",
    recycleChip: "回收筹码",
    editProportion: "编辑分成",
    availableProportion: "可用占比",
    unionOwn: "联盟持有",
    clubOwn: "俱乐部持有",
    superProxyOwn: "超级代理持有",
    proxyOwn: "代理持有",
    palyerOwn: "玩家持有",
    shieldGamble: "牌局屏蔽",
    bbLevel1: "微级別(BB: < 5)",
    bbLevel2: "小级別(BB:5 - 10)",
    bbLevel3: "中级別(BB:20 - 100)",
    bbLevel4: "高级別(BB: 100+)",
    anteLevel1: "微级別(Ante: < 5)",
    anteLevel2: "小级別(Ante:5 - 10)",
    anteLevel3: "中级別(Ante:20 - 100)",
    anteLevel4: "高级別(Ante: 100+)",
    scoreLevel1: "微级別(底分: < 5)",
    scoreLevel2: "小级別(底分:5 - 10)",
    scoreLevel3: "中级別(底分:20 - 100)",
    scoreLevel4: "高级別(底分: 100+)",
    applyLevel1: "微级別(报名费: < 5)",
    applyLevel2: "小级別(报名费:5 - 10)",
    applyLevel3: "中级別(报名费:20 - 100)",
    applyLevel4: "高级別(报名费: 100+)",
    feeMatch: "免费赛",
    integralRecord: "积分记录",
    clubInfo: "俱乐部信息",
    proxyInfo: "代理信息",
    dataRecord: "数据记录",
    loginRecord: "登录记录",
    proxyData: "代理数据",
    gameData: "游戏数据",
    integralData: "积分数据",
    gameAndIntegralData: "游戏&积分数据",
    yesterday: "昨日",
    sevenDay: "最近七日",
    addConfig: "添加{}配置",
    importConfig: "导入{}配置",
    importConfigFile: "导入配置文件",
    pot: "底池",
    playerNumber: "玩家数",
    handCard: "手牌",
    gambleStatistics: "牌局统计",
    recordDetail: "战绩详情",
    playerList: "玩家列表",
    setEmptyTableCard: "设置空位牌桌",
    createGambleTableRound: "创建牌局",
    publish: "发布",
    dissolve: "解散",
    createMatch: "创建赛事",
    monday: "周一",
    tuesday: "周二",
    wednesday: "周三",
    thursday: "周四",
    friday: "周五",
    saturday: "周六",
    sunday: "周日",
    eventSummary: "赛事汇总",
    accountInfo: "账号信息",
    integralConsumeRecord: "积分消耗流水",
    openConsumeRecord: "开局消耗流水",
    exchangeConsumeRecord: "兑换积分流水",
    distributionRecord: "分销流水",
    createHighHandCard: "创建HighHandCard",
    activityRecord: "活动记录",
    offLine: "下线",
    freeLimitedTime: "限时免费",
    aggregate: "总计",
    agree: "同意",
    refuse: "拒绝",
    createProxy: "创建代理",
    accessConfig: "接入配置",
    copyAndSave: "复制并保存",
    proxyInformation: "代理资料",
    systemCode: "系统代码",
    commonCard: "公共牌",
    winSquid: "获得鱿鱼",
    squidResult: "鱿鱼结算",
    singleMode: "单倍模式",
    normalMode: "普通模式",
    crazyModel: "疯狂模式",
    remoteHolder: "后手",
    buy: "购买",
    compensate: "赔付",
    odds: "赔率",
    transferCards: "转牌",
    drawCards: "和牌",
    passivePurchase: "被动购买",
    activePurchase: "主动购买",
    firstRound: "首轮",
    twoRound: "第二轮",
    threeRound: "第三轮",
    fourRound: "第四轮",
    fiveRound: "第五轮",
    fold: "弃牌",
    generalAgent: "次总代",
    owner: "拥有者",
    admin: "管理者",
    member: "成员",
    tenPercent: "10%",
    fifteenPercent: "15%",
    twentyPercent: "20%",
    thirtyPercent: "30%",
    fixedBonus: "固定奖金",
    notPublish: "未发布",
    notStart: "未开始",
    process: "进行中",
    finished: "已结束",
    dissolved: "已解散",
    published: "已发布",
    deleted: "已删除",
    offline: "已下线",
    pendingReview: "待审核",
    systemReissue: "系统补发",
    systemNotReissue: "系统不补发",
    reviewedAndReissued: "已审核-补发",
    reviewedAndNotReissued: "已审核-不补发",
    standard: "标准",
    speediness: "快速",
    deepChip: "深筹",
    manualPublish: "手动发布",
    autoPublish: "自动发布",
    everyDayPublish: "每天定时开赛",
    everyWeekPublish: "每周特定天开赛",
    all: "所有",
    tablePlayers: "在桌玩家",
    oneself: "仅自己",
    bloodBattleMode: "血战模式",
    bloodFlowsInOut: "血进血出",
    meantime: "同时",
    inOrder: "顺序",
    minute: "分钟",
    playPeople: "在玩人数",
    clubTableRound: "俱乐部局",
    unionTableRound: "联盟局",
    superUnionTableRound: "超盟局",
    createOwnerUid: "创建者UID",
    summarize: "本页汇总",
    playerChip: "玩家筹码",
    total: "共",
    item: "条",
    consumeType: "消耗类型",
    handCardId: "手牌ID",
    hint: "提示",
    everyHoursConsumeDiamond: "每小时消耗钻石",
    originalPrice: "原价",
    currentPrice: "现价",
    superUnionServiceContributionProportion: "上级超盟服务费贡献比例",
    unionServiceContributionProportion: "本联盟服务费贡献比例",
    editWhitelist: "编辑IP白名单",
    proxySystemAddress: "代理后台地址",
    apiAddress: "API地址",
    yes: "是",
    no: "否",
    lossSetting: "亏损设置",
    unionInfo: "联盟信息",
    remainingQuota: "（剩余额度：{}）",
    dubiousGamble: "可疑牌局",
    game: "游戏",
    createHandRank: "创建手数排行",
    createTask: "创建任务",
    importTask: "导入任务",
    editOrder: "编辑排序",
    recharge: "充值",
    onlineAccessDocument: "在线接入文档",
    pleaseSaveAccountPassword: "请保存账号密码",
    proxyAccountPassword: "代理账号密码",
    playerData: "玩家数据",
    gambleDetail: "牌局详情",
    handDetail: "手牌详情",
    endGamble: "结束牌局",
    started: "已开始",
    hand: "手",
    person: "人",
    count: "次",
    hour: "小时",
    second: "秒",
    unlimited: "无上限",
    double: "倍",
    gambleTable: "牌桌",
    serviceFeeSharingRatio: "服务费分成比例",
    insuranceSharingRatio: "保险分成比例",
    cowboySharingRatio: "牛仔分成比例",
    cowboyMode: "牛仔模式",
    diamondLog: "钻石记录",
    playerInfo: "玩家信息",
    lowerProxy: "下线代理",
    lowerPlayer: "下线玩家",
    proportionData: "占成数据",
    pageNotExist: "抱歉，您访问的页面不存在。",
    backHomepage: "返回首页",
    cancelled: "已注销",
    writeOff: "注销",
    createTickets: "创建门票",
    editTickets: "编辑门票",
    editMatch: "编辑比赛",
    rewardsNumber: "奖励人数",
    matchStatistics: "赛事统计",
    autoRebuy: "自动Rebuy",
    giveUpRebuy: "放弃Rebuy",
    autoAllin: "自动Allin",
    autoFold: "自动Fold",
    aiPlayCard: "Ai玩牌",
    playingRobot: "在玩机器人",
    participated: "已参赛",
    cancelApply: "取消报名",
    batchApply: "批量报名",
    applyTool: "报名工具",
    refresh: "刷新",
    dataStatistics: "数据统计",
    testTool: "测试工具",
    currentUnion: "当前联盟",
    currentSuperUnion: "当前超盟",
    administrator: "管理员",
    service: "客服",
    financing: "商务",
    managementLayer: "管理层",
    consumeIntegral: "消耗积分",
    createMttMatch: "创建MTT赛事",
    editMttMatch: "编辑MTT赛事",
    selectPageExport: "选择页数导出",
    discardedHandNumber: "弃牌手数",
    notServiceFeeHandNumber: "无服务费手数",
    betBoolHandNumber: "底池<10BB手数",
    enterBollHandNumber: "入池手数",
    drawHandNumber: "翻牌手数",
    notBetBoolHandNumber: "无底池费的手数",
    twoPeopleGambleHandNumber: "2人牌局手数",
    threePeopleGambleHandNumber: "3人牌局手数",
    notLuckfeeHandNumber: "无luckfee的牌局数",
    totalContributeServiceFee: "总贡献服务费",
    everyHandServiceFeeBb: "每手贡献服务费BB数",
    diamondBalance: "钻石余额",
    reconciliationDate: "对账时间",
    reconciliationStartDate: "对账开始时间",
    reconciliationEndDate: "对账结束时间",
    exportEndPageTooLargeVerify: "结束页必须大于起始页！",
    cowboyText: "牛仔",
    operateRecord: "操作记录",
    counterDiamondRecord: "柜台钻石记录",
    autoAddon: "自动Addon",
    giveUpAddon: "放弃Addon",
    exportDataRecord: "导出数据记录",
    hangMode: "夯场模式",
    hangModeTips: '当前Ante和买入范围为"夯"场数值，拖动买入范围可自动关闭"夯"场开关',
    exportLoaddingMessage: "正在导出中请等待...",
    exportGambleRecord: "导出牌局记录",
    day: "天",
    page: "页",
    prop: "道具",
    propCusomeGiveIn: "道具消耗交上",
    propCusomeContribution: "道具消耗贡献",
    publishMinuteLimit: "分钟数不能超过 7 天",
    palyingType1: "鱿鱼",
    palyingType2: "夯场",
    palyingType3: "Normal",
    palyingType3Suffix: "（鱿鱼和夯场以外）",
    basicInfo: "基本信息",
    rewardConfig: "奖励配置",
    winnerPlayer: "中奖玩家",
    notSeriesMatch: "非系列赛",
    seriesMatch: "系列赛",
    proportionRecord: "比例记录",
    proportionConfig: "比例配置",
    configRecord: "配置记录",
    effectiveRecord: "生效记录",
    publishRecord: "发布记录",
    allVersion: "全部",
    GameIntegral: "游戏积分",
    claimPeople: "领取人数(排重)",
    integralSendTotalNumber: "积分发放总额",
    ticketSendNumber: "门票发放数",
    claimTimes: "领取次数",
    perCapitaFrequency: "人均次数",
    perCapitaAmount: "人均金额",
    playCardPepole: "玩牌人数",
    claimRate: "领取率",
    operationPersonId: "操作人UID",
    operationPersonName: "操作人名称",
    operationPersonRole: "操作人角色",
    operationType: "操作类型",
    operationDetail: "操作详情",
    operationedPlayerId: "被操作玩家ID",
    operationedPlayerName: "被操作玩家名称",
    proxyInfo: "代理信息",
    derivativeInitiatorName: "倒分发起者昵称",
    derivativeReceiverName: "倒分接收者昵称",
    invertIntegral: "倒取积分",
    invertBlindNumber: "倒取盲注数",
    betPeopleNumber: "下注人数",
    cardGameTime: "牌局时间",
    exceptionType: "异常类型",
    transferWallet: "转账钱包",
    seamlessWallet: "无缝钱包",
    proxyIdSuffix: "(代理唯一标识，游戏系统生成唯一绑定的api接口参数)",
    proxySuffix: "(用于后台展示区分代理)",
    zh: "中文繁体",
    en: "英文",
    th: "泰文",
    vn: "越南文",
    id: "印尼文",
    pt: "葡萄牙文",
    ko: "韩文",
    spa: "西班牙文",
    lao: "老挝语",
    my: "缅甸语",
    jp: "日文",
    bn: "孟加拉语",
    rs: "俄罗斯语",
    tr: "土耳其语",
    changePassword: "修改密码",
    changePasswordSuccess: "修改成功，请重新登陆",
    myIncome: "我的收益",
    incomeBase: "收益基数",
    luckcardAndJackpot: "LC&JP",
    luckcardAndJackpotProfit: "LC&JP占成",
    income: "收益",
    editLossLimit: "编辑亏损限制",
    distributed: "已发放",
    notDistributed: "未发放",
    serverDate: "服务器时间",
    exportAllExcel: "导出所有到Excel",
    gameServerIpAddress: "游戏服务器请求出口IP",
    editCallbackAddress: "编辑回调地址",
    serviceFeesIncome: "服务费收益",
    insuranceIncome: "保险收益",
    cowboysIncome: "牛仔收益",
    LCAndJPIncome: "LC&JP收益",
    ace1PlayerId: "Ace1玩家ID",
    practiceCourt: "练习场",
    betId: "注单ID",
    editPassword: "编辑密码",
    initPassword: "初始密码",
    initPasswordTips: "初始密码已被修改，密码非明文不可查",
    deleteAllConfig: "删除所有配置",
    closeAllTable: "关闭所有牌桌",
    addWhitelist: "添加白名单",
    generalUnion: "普通联盟",
    apiUnion: "API联盟",
    directUnion: "直营联盟",
    recruitmentAgentLink: "招募代理链接",
    proxyName: "代理名称",
    proxyGameId: "代理游戏ID",
    proxyGameName: "代理游戏昵称",
    agreeApplication: "同意申请",
    registerIp: "注册IP",
    username: "用户名称",
    email: "邮箱",
    pending: "待处理",
    agreed: "已同意",
    rejected: "已拒绝",
    language: "语言",
    verificationCodeSource: "验证码用途",
    verificationCode: "验证码",
    areaCode: "区号",
    overheadInformation: "附加信息",
    succeed: "成功",
    failed: "失败",
    customTime: "自选时间",
    exportAllLevels: "导出各级数据",
    createCustomer: "创建客服",
    editCustomer: "编辑客服",
    onlineCustomer: "在线客服",
    close: "关闭",
    open: "开启",
    otherAccount: "其他账号",
    fourCopies: "4张",
    fiveCopies: "5张",
    sixCopies: "6张（7座位）",
    linkAddress: "链接地址",
    updateVersion: "更新版本",
    luckycardWinNumber: "LC中奖次数",
    extractionRatio: "抽取比例",
    extractionRatioAndPrizePoolSize: "抽取比例/奖池规模（$/100）",
    apiPropConsume: "API道具消耗",
    diamondDistributionTotal: "钻石分销总额",
    operatorId: "操作人ID",
    operatorName: "操作人昵称",
    operatorRole: "操作人角色",
    byOperatorId: "被操作人ID",
    byOperatorName: "被操作人昵称",
    byOperatorRole: "被操作人角色",
    newUserNumber: "新用户数",
    luckcardAndJackpotIncomBase: "LC&JP收益基数",
    profitAndLossCowboy: "盈亏_COWBOY",
    proportionDescription: "1联盟币：x本地币",
    oldProportion: "旧比例",
    newProportion: "新比例",
    operationTime: "操作时间",
    gapWin: "GAP正",
    gapLose: "GAP负",
    exportCheckData: "导出对账数据",
    superUnionData: "超盟数据",
    unionData: "联盟数据",
    registerStartTime: "注册开始日期",
    registerEndTime: "注册结束日期",
    sushiBonus: "寿司奖金",
    supplementaryNote: "补充前注",
    receiveRewards: "收取奖励",
    intervalSummaryData: "区间汇总数据",
};
